import React from 'react';
import ShareIconWhite from '../../images/svg-gcbooks/share-icon';
import BookIconWhite from '../../images/svg-gcbooks/book-icon';
import ShareMenu from '../accessories/shareMenu';
import AudioToggleButton from '../../modules/books-page/audioToggleButton';
import './ChapterActions.scss';
import { AppContext } from '../../apollo/wrap-root-element';
import { Link } from 'gatsby';
import { getFullChapterPublicPath, getGcUi } from '../../constants/spanish-gc';

export default function ChapterActions({
  setShowReadModal,
  showShareMenu,
  setShowShareMenu,
  audioDetails,
  showReadButton = true,
  showListenButton = true,
  locale = 'en',
  chapterUid,
  useFullReadPage = false,
  fullReadPath,
}) {
  const { currentChapterIndex } = React.useContext(AppContext);
  const ui = getGcUi(locale);
  const defaultChapterUid =
    locale === 'es' ? `gc-es-chapter${currentChapterIndex + 1}` : `gc-chapter${currentChapterIndex + 1}`;
  const readChapterPath =
    fullReadPath || getFullChapterPublicPath(chapterUid || defaultChapterUid);

  return (
    <div className="chapter-actions-container">
      <div className="chapter-actions">
        <button className="control-button" onClick={() => setShowShareMenu(!showShareMenu)}>
          <ShareIconWhite />
          <span className="label">{ui.shareChapter}</span>
          {showShareMenu ? <ShareMenu /> : ''}
        </button>

        {showReadButton &&
          (useFullReadPage ? (
            <Link to={readChapterPath} className="control-button">
              <BookIconWhite color="#fecb04" />
              <span className="label">{ui.readChapter}</span>
            </Link>
          ) : (
            <div onClick={() => setShowReadModal(true)} role="button" className="control-button">
              <BookIconWhite color="#fecb04" />
              <span className="label">{ui.readChapter}</span>
            </div>
          ))}

        {showListenButton && (
          <AudioToggleButton text={ui.listenToChapter} audioDetails={audioDetails} />
        )}
      </div>
    </div>
  );
}
